module.exports = __webpack_public_path__ + "static/img/linktoQQ1.df8452a1.jpg";